// Page headline on a paper strip held by two pieces of masking tape (same look as the Start hero).
export default function PageTitle({
  children,
  size = "text-[clamp(26px,3.6vw,52px)]",
  stack = false,
  className = "",
  tilt = "-rotate-1",
}: {
  children: React.ReactNode;
  size?: string;
  stack?: boolean;
  className?: string;
  tilt?: string;
}) {
  return (
    <h1
      className={`pt-in relative m-0 ${tilt} justify-self-start self-start ${size} leading-[1.05] font-bold tracking-[-0.025em] text-[#2B2620] ${className}`}
    >
      <span
        className={`${stack ? "grid" : "block"} bg-[#F1E8D6] bg-cover bg-center px-5 py-3 shadow-[0_2px_3px_rgba(20,15,10,.25),0_14px_26px_-10px_rgba(20,15,10,.45)] min-[640px]:px-9 min-[640px]:py-5`}
        style={{ backgroundImage: "url(/d/242a48ae2ddd28e80567dcf403efc07c.jpg)" }}
      >
        {children}
      </span>
      <span aria-hidden="true" className="ttag pt-tape absolute -top-2 -left-3 block h-6 w-16 -rotate-[28deg] !p-0 opacity-90 min-[640px]:-top-3 min-[640px]:-left-5 min-[640px]:h-7 min-[640px]:w-24" />
      <span aria-hidden="true" className="ttag pt-tape absolute -right-3 -bottom-2 block h-6 w-16 -rotate-[28deg] !p-0 opacity-90 min-[640px]:-right-5 min-[640px]:-bottom-3 min-[640px]:h-7 min-[640px]:w-24" />
    </h1>
  );
}
